module.exports = __webpack_public_path__ + "img/c-en-04.a8f89164.png";